import { useState, useEffect, useCallback, useRef } from "react";
import DynamicTable from "../../ui/DynamicTable";
import config from "../../../config/config";
import { BsThreeDotsVertical } from "react-icons/bs";
import Pagination from "../../ui/Pagination";
import { refreshToolTipTableData } from "../../../observers/dataObserver";
import RenderForms from "./renderForms";
const ToolTipTable = () => {
    const [rows, setRows] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState({});
    const [currentTable, setCurrentTable] = useState(null);
    const [showForm, setShowForm] = useState(false);
    const [currentRow, setCurrentRow] = useState(null);
    const [pagination, setPagination] = useState({
        current_page: 1,
        total_items: 0,
        total_pages: 0,
        limit: 10
    });
    const dropdownRef = useRef(null);



    const getAuthHeaders = () => ({
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
    });

    const handlePageChange = (pageNumber) => {
        setPagination((prevPagination) => ({
            ...prevPagination,
            current_page: pageNumber
        }));
    };

    const toggleDropdown = useCallback((id) => {
        setDropdownOpen((prev) => {
            const isOpen = prev[id];
            return isOpen
            ? {} // Close all if current is open
            : { [id]: true }; // Open only the current one
        });
    },[]);





    const fetchToolTips = useCallback(async () => {
        try {
            console.log("tooltip clicked");
            const response = await fetch(`${config["backend-url"]}/get_tooltips?page=${pagination.current_page}&limit=${pagination.limit}`, {
                method: "GET",
                headers: getAuthHeaders()
            });
    
            const data = await response.json();
            
            // ✅ Extract and set table rows
            if (response.ok && Array.isArray(data.data)) {
                setRows(data.data);
    
                // ✅ Optional: update pagination if included in response
                if (data.pagination) {
                    setPagination((prev) => ({
                        ...prev,
                        total_pages: data.pagination.total_pages || 1,
                        total_items: data.pagination.total_items || 0
                    }));
                }
            } else {
                console.warn("Unexpected API response:", data);
            }
        } catch (error) {
            console.error("❌ Error fetching tooltips:", error);
        }
    }, [pagination.current_page, pagination.limit]);
    
    const toggleRowStatus = useCallback(async (row, status) => {
        try {
            const response = await fetch(`${config["backend-url"]}/Change_Required_Table`, {
                method: "POST",
                headers: getAuthHeaders(),
                body: JSON.stringify({
                    tableName: "Tooltips",
                    row: { id: row.id },
                    status, // "Activate" or "Deactivate"
                }),
            });
        
            const result = await response.json();
            if (!response.ok) throw new Error(result.message || "Failed to update status");
            setPagination((prevPagination) => ({
                ...prevPagination,
                current_page: 1
            }));
            fetchToolTips();
            // alert(`✅ ${status}d row successfully`);
        } catch (err) {
            console.error("❌ Failed to update status:", err);
            // alert("Failed to update row status.");
        }
    }, [fetchToolTips]);

    const renderActionDropdown = useCallback((_, row) => {
        return (

            <div className="dropdown-container" key={row.id} ref={dropdownOpen[row.id] ? dropdownRef : null}>
            <button
                onClick={() => toggleDropdown(row.id)}
                className="dropdown-btn"
            >
                <BsThreeDotsVertical size={20} />
            </button>
            {dropdownOpen[row.id] && (
                <div className="custom-dropdown">
                   
                  <div
  className="dropdownItem"
  onClick={() => {
    console.log("row content:", row);
    const selectedRow = {
        id: row.id, 
        LabelName: row.Label,
        FieldName: row["Field Name"],         // ✅ access key with space
        ToolTipText: row.TootipText || "",    // ✅ fix typo key
      };

    console.log("Editing row data:", selectedRow); // ✅ See what row is being passed

    setCurrentRow(selectedRow);
    setCurrentTable("Tooltips");
    setShowForm(true);
  }}
>
  Edit
</div>
                </div>
            )}
            </div>
        );
    },[dropdownOpen, toggleDropdown, toggleRowStatus, dropdownRef]);

    const renderStatus = useCallback((value) => (
        <span className={`status-tile status-${value ? "active" : "inactive"}`}>
          {value ? "Active" : "Inactive"}
        </span>
    ),[]);

    useEffect(() => {
        fetchToolTips();

        refreshToolTipTableData.subscribe(() => {
            fetchToolTips();
        });

    }, [fetchToolTips]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen({});
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const columns = [
                    { key: "Label", label: "Label" },
                    { key: "TootipText", label: "Tootip Text" },
                    { key: "Field Name", label: "Field Name" },
                    { key: "status", label: "Status", render: renderStatus },
                    { key: "active", label: "Actions", render: renderActionDropdown },
                ]

    return (
        <>
            <DynamicTable columns={columns} data={rows} />
            <Pagination totalPages={pagination.total_pages} page={pagination.current_page} handlePageChange={handlePageChange} />
            <RenderForms table={currentTable} show={showForm} onClose={()=>setShowForm(false)}   initialData={currentRow}/>
        </>
    )

}

export default ToolTipTable;